var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c("BjDivider", [_vm._v(_vm._s(_vm.$t("screenWMS.lampConfig")))]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.basket"),
                        prop: "basketId",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.basket"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.basketId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "basketId", $$v)
                          },
                          expression: "form.basketId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: _vm.colSpan } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("screenWMS.lamp"),
                        prop: "lampIndex",
                      },
                    },
                    [
                      _c("BjInputNumber", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("screenWMS.lamp"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.lampIndex,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "lampIndex", $$v)
                          },
                          expression: "form.lampIndex",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }